import { module } from 'modujs';
import { format_price } from '../utils/cart'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        /**
         * -Variants `variants` are automatically generated unique product id with combinaison of options.
         * -Options `options` are list of customizable parameters available for customer without variants context.
         * -CurrentVariant is the first product variant that is available for purchase.
         * -AvailabeColors are the global colors set in ACF shop settings.
         *
         */
        this.productId = JSON.parse(this.getData('product-id'))
        this.productVariants = JSON.parse(this.$('productVariants')[0].innerHTML)
        this.productOptions = JSON.parse(this.getData('options'))
        this.productCurrentVariant = JSON.parse(this.$('currentVariant')[0].innerHTML)
        this.availableColors = JSON.parse(this.getData('available-colors'))
        this.productQuantities = JSON.parse(this.getData('quantities'))

        this.productCurrentOptions = this.productCurrentVariant.options.map((value, index) => {
            return { name: this.productOptions[index].name, value: value }
        })

        /**
         * Feedback messages
         *
         */
        this.messages = JSON.parse(this.getData('feedback-messages'))

        // this.swymCallbackFn = () => {
        //     var wishlistButton = document.querySelector(".wishlist-btn");
        //     if(wishlistButton){
        //         wishlistButton.addEventListener("click", function(e){
        //             if(SwymPageData){
        //                 SwymPageData.et = 4;  // et 4 stands for wishlist event type
        //                 _swat.addToWishList(SwymPageData, function(e){
        //                     wishlistButton.innerHTML = "Saved";
        //                 });
        //             }
        //         });
        //     }
        // }
        // if(!window.SwymCallbacks){
        //     window.SwymCallbacks = [];
        // }
        // window.SwymCallbacks.push(swymCallbackFn);

        // console.log(SwymPageData)

        this.initVue()
    }

    /**
     * Init Vue App, Add Vue plugins, etc
     *
     */
    initVue() {
        let that = this

        this.app = new Vue({
            el: this.el,
            delimiters: ['${', '}'],
            data: () => {
                return {
                    messages:           this.messages,
                    productId:          this.productId,
                    productVariants:    this.productVariants,
                    productOptions:     this.productOptions,
                    currentVariant:     this.productCurrentVariant,
                    currentOptions:     this.productCurrentOptions,
                    productQuantities:  this.productQuantities,
                    availableColors:    this.availableColors,
                    quantity:           1,
                    maxQuantity:        1,
                    isAvailable:        false,
                    currentMessage:     false,
                    isQuantityExceed:   false,
                    notifyEmail:        '',
                    isNotified:         false,
                    notifyActive:       false
                }
            },
            watch: {
                quantity: function (newQuantity, oldQuantity) {
                    if(newQuantity >= this.maxQuantity) {
                        this.quantity = this.maxQuantity
                    }
                }
            },
            computed: {

            },
            methods: {
                /**
                 * Manage add to cart button state :disabled
                 *
                 * @param
                 */
                disableAddToCart: function() {
                    return !this.isAvailable
                },

                /**
                 * Update current variant by parsing current options to see if it match any available variant
                 *
                 * @param
                 */
                updateCurrentVariant: function(event) {
                    if(typeof event == "undefined") {
                        this.updateColorImages()
                    } else {
                        if (this.isColor(event.currentTarget.name)) {
                            this.updateColorImages()
                        }
                    }

                    let optionsValue = this.currentOptions.map(option => option.value)

                    this.currentVariant = this.productVariants.find((variant) => {
                        const variantOptions = variant.options.filter(item => typeof item == 'string')
                        return variantOptions.join(',') == optionsValue.join(',')
                    })

                    this.maxQuantity = this.productQuantities.find((quantity) => {
                        return quantity.id == this.currentVariant.id
                    }).quantity

                    this.quantity = 1

                    console.log('Current Variant ID:', this.currentVariant.id)
                    this.updateState()
                },

                /**
                 * Update available state. This determines if currrent product combination can be added to cart
                 *
                 * @param
                 */
                updateState: function() {
                    //Clear feedback message
                    this.currentMessage = false

                    // Current variant doesn't exist
                    if(typeof this.currentVariant === 'undefined') {
                        this.setMessage('error')

                        console.warn('The variant does not exist.')

                        return this.isAvailable = false
                    }

                    // Check if variant is available
                    if(!this.currentVariant.available) {
                        this.setMessage('outOfStock')
                        return this.isAvailable = false
                    } else {
                        return this.isAvailable = true
                    }
                },

                /**
                 * Udpate feedback message
                 *
                 * @param
                 */
                setMessage: function(type) {
                    this.currentMessage = this.messages.find((item) => {
                        return item.type == type
                    }).message
                },

                /**
                 * Add to cart!
                 *
                 * @param event
                 */
                addToCart: function() {
                    that.call('addItem', {
                        "id": this.currentVariant.id,
                        "quantity": this.quantity
                    }, 'Cart')
                },

                /**
                 * Format option if it's a color.
                 *
                 * @param
                 */
                formatValueName: function(option, value) {
                    if(!this.isColor(option.name)) {
                        return value
                    } else {
                        return value.split('#')[0]
                    }
                },

                /**
                 * Format option if it's a color.
                 *
                 * @param
                 */
                colorStyles: function(option, value) {
                    if(!this.isColor(option.name)) {
                        return false
                    } else {
                        const color = this.fetchAvailableColor(value)
                        const hex   = (typeof color != 'undefined') ? color.hex : false

                        if(hex) {
                            return {
                                color: hex,
                                background: hex
                            }
                        } else {
                            console.warn(`There was not color match found for ${value}.`)
                            return false
                        }
                    }
                },

                /**
                 * Check if option is a color
                 *
                 * @param {string} option name
                 */
                isColor: function(name) {
                    return (name.toUpperCase() == "COLOR" || name.toUpperCase() == "COULEUR") ? true : false
                },

                /**
                 * Update the carousel with the current color selected
                 *
                 * @param
                 */
                updateColorImages: function() {
                    this.currentOptions.forEach((option) => {
                        if (this.isColor(option.name)) {
                            that.call('filter', option.value, 'CarouselProduct')
                        }
                    })
                },

                /**
                 * Format price
                 *
                 * @param
                 */
                formatedCurrentPrice: function(price) {
                    return format_price(price)
                },

                /**
                 * Fetch color from Available Color
                 *
                 * @param {value} string :: Color value
                 */
                fetchAvailableColor(value) {
                    if (this.availableColors) {
                        return this.availableColors.find(color => color.name == value)
                    } else {
                        return false
                    }
                },

                submitNotify: function(event) {
                    event.preventDefault()
                    const notifyEmail = this.notifyEmail;

                    if(window.SI) {
                        SI.create(notifyEmail, this.currentVariant.id, this.productId).then((response) => {
                            this.isNotified = true

                            this.notifyEmail = ''
                            event.target.reset()
                        })
                    } else {
                        console.warn('window.SI does not exist.')
                    }
                },

                /**
                 *
                 *
                 * @param
                 */
                toggleNotify: function() {
                    this.notifyActive = !this.notifyActive
                },

                decrementQuantity: function() {
                    if(this.quantity > 0) {
                        this.quantity = this.quantity - 1
                    }
                },

                incrementQuantity: function() {
                    if(this.quantity < this.maxQuantity) {
                        this.quantity = this.quantity + 1
                    }
                },

                // saveWishlist: function() {
                //     if(SwymPageData){
                //         SwymPageData.et = 4;  // et 4 stands for wishlist event type
                //         _swat.addToWishList(SwymPageData, function(e){
                //             // wishlistButton.innerHTML = "Saved";
                //             console.log('SAVED')
                //         });
                //     }
                // }
            },
            mounted: function () {
                this.$nextTick(function () {
                    this.updateCurrentVariant()
                })
            },
            updated: function () {
                this.$nextTick(function () {
                    that.call('update', null, 'Scroll')
                })
            }
        })
    }

    /**
     * Destroy instances & stuff
     *
     */
    destroy() {
        super.destroy()
        this.app.$destroy()
    }
}
